import React from 'react';
import '../styles/ViewToggle.css';
import { HugeiconsIcon } from '@hugeicons/react';
import { colour } from '../styles/GlobalStyles';

/**
 * Segmented control for switching between views (e.g. table / map / cards).
 *
 * Props:
 *  - options: [{ key, icon, label }]  — `icon` is a Hugeicons icon object
 *  - value: the currently selected option key
 *  - onChange: (key) => void
 *  - ariaLabel: accessible label for the tablist (default "View")
 *  - loading: dims the control while a background fetch is in flight
 */
function ViewToggle({ options = [], value, onChange, ariaLabel = 'View', loading = false }) {
    return (
        <div
            className={`view-toggle${loading ? ' view-toggle-loading' : ''}`}
            role="tablist"
            aria-label={ariaLabel}
            aria-busy={loading}
        >
            {options.map(({ key, icon, label }) => {
                const active = key === value;
                return (
                    <button
                        key={key}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        className={`view-toggle-option body-semibold${active ? ' view-toggle-option-active' : ''}`}
                        onClick={() => onChange(key)}
                        disabled={active}
                    >
                        {icon && <HugeiconsIcon icon={icon} color={active ? colour.gray07 : colour.gray05} size={14} />}
                        <span>{label}</span>
                    </button>
                );
            })}
        </div>
    );
}

export default ViewToggle;
